// import L from "leaflet";
import {
  current_off,
  current_on,
  location,
  map_button_off,
  map_button_on,
  sat_button_off,
  sat_button_on,
  temp_off,
  temp_on,
  tide_off,
  tide_on,
  water_off,
  water_on,
} from "@/assets/_base64";
import { postMessageToReact } from "@/services/reactNativeWebView";
import * as assets from "../assets/_base64";

// let rectangels = [];
let icons = [];

const filterButtonsData = {
  wind: {
    elId: "currentbutton",
    id: "current_filter",
    imgOff: current_off,
    imgOn: current_on,
  },
  temp: {
    elId: "tempbutton",
    id: "temp_filter",
    imgOff: temp_off,
    imgOn: temp_on,
  },
  water: {
    elId: "waterbutton",
    id: "water_filter",
    imgOff: water_off,
    imgOn: water_on,
  },
  tide: {
    elId: "tidebutton",
    id: "tide_filter",
    imgOff: tide_off,
    imgOn: tide_on,
  },
};

const handleFilterButtonClick = (filterType = {}, self) => {
  const imgEl = document.getElementById(filterType.elId);
  const filter = self[filterType.id];

  if (!filter) {
    for (var prop in filterButtonsData) {
      if (filterType.elId === filterButtonsData[prop].elId) {
        imgEl.src = filterType.imgOn;
        self[filterButtonsData[prop].id] = true;
        const eFilter = {
          filterChangedTo: filterButtonsData[prop].id,
          source: "waterScreen",
        };
        setTimeout(function() {
          postMessageToReact(JSON.stringify(eFilter));
        });
      } else {
        const otherImgEl = document.getElementById(
          filterButtonsData[prop].elId
        );
        otherImgEl.src = filterButtonsData[prop].imgOff;
        self[filterButtonsData[prop].id] = false;
      }
    }
    self.filter_type();
    self.getStationsList(true);
  }
};

export const addFilterButtons = (leafletMap, self) => {
  L.Control.Cust2 = L.Control.extend({
    onAdd: function() {
      var table = L.DomUtil.create("table");
      table.setAttribute("id", "empTable");
      table.style.backgroundColor = "white";
      table.style.borderRadius = "10px";

      table.style.marginBottom = "25px";
      table.style.border = "2px solid lightgray";
      var tr = table.insertRow(-1);
      // tr.style.borderRadius = 10;

      /* first -current- button */
      /////////////////
      var current_button = L.DomUtil.create("input");
      current_button.type = "image";
      current_button.setAttribute("id", "currentbutton");
      current_button.title = "current";
      current_button.value = "current";
      current_button.src = self.current_filter ? current_on : current_off;
      current_button.style.width = "20px";
      current_button.style.margin = "5px";
      // current_button.style.border = "solid 3px green;";
      current_button.style.float = "left";
      // current_button.style.border = "none";
      current_button.style.outline = "none";
      L.DomEvent.addListener(
        current_button,
        "click",
        this._clicked_current,
        this
      );
      L.DomEvent.disableClickPropagation(current_button);
      tr.appendChild(current_button);

      var div_line = L.DomUtil.create("div");
      div_line.style.borderLeft = "2px solid lightgray";
      div_line.style.height = "24px";

      div_line.style.margin = "4px";
      div_line.style.float = "left";
      tr.appendChild(div_line);

      /* second -water- button */
      /////////////////
      var temp_button = L.DomUtil.create("input");
      temp_button.setAttribute("id", "tempbutton");
      temp_button.type = "image";
      temp_button.title = "No cat";
      temp_button.value = "28";
      temp_button.src = self.temp_filter ? temp_on : temp_off;
      temp_button.style.width = "20px";
      temp_button.style.margin = "5px";
      temp_button.style.border = "none";
      temp_button.style.outline = "none";
      temp_button.style.float = "left";
      L.DomEvent.addListener(temp_button, "click", this._clicked_temp, this);
      L.DomEvent.disableClickPropagation(temp_button);
      tr.appendChild(temp_button);

      var div_line2 = L.DomUtil.create("div");
      div_line2.style.borderLeft = "2px solid lightgray";
      div_line2.style.height = "24px";

      div_line2.style.margin = "4px";
      div_line2.style.float = "left";
      tr.appendChild(div_line2);

      /* third -water- button */
      /////////////////
      var water_button = L.DomUtil.create("input");
      water_button.setAttribute("id", "waterbutton");
      water_button.type = "image";
      water_button.title = "No cat";
      water_button.value = "28";
      water_button.src = self.water_filter ? water_on : water_off;
      water_button.style.width = "20px";
      water_button.style.margin = "5px";
      water_button.style.border = "none";
      water_button.style.outline = "none";
      water_button.style.float = "left";
      L.DomEvent.addListener(water_button, "click", this._clicked_water, this);
      L.DomEvent.disableClickPropagation(water_button);
      tr.appendChild(water_button);

      var div_line3 = L.DomUtil.create("div");
      div_line3.style.borderLeft = "2px solid lightgray";
      div_line3.style.height = "24px";

      div_line3.style.margin = "4px";
      div_line3.style.float = "left";
      tr.appendChild(div_line3);

      /* fourth - tide- button */
      /////////////////
      var tide_button = L.DomUtil.create("input");
      tide_button.setAttribute("id", "tidebutton");
      tide_button.type = "image";
      tide_button.title = "No cat";
      tide_button.value = "28";
      tide_button.src = self.tide_filter ? tide_on : tide_off;
      tide_button.style.width = "20px";
      tide_button.style.margin = "5px";
      tide_button.style.border = "none";
      tide_button.style.outline = "none";
      L.DomEvent.addListener(tide_button, "click", this._clicked_tide, this);
      L.DomEvent.disableClickPropagation(tide_button);
      tr.appendChild(tide_button);

      return table;
    },
    _clicked_current: function() {
      handleFilterButtonClick(filterButtonsData.wind, self);
    },
    _clicked_temp: function() {
      handleFilterButtonClick(filterButtonsData.temp, self);
    },
    _clicked_water: function() {
      handleFilterButtonClick(filterButtonsData.water, self);
    },
    _clicked_tide: function() {
      handleFilterButtonClick(filterButtonsData.tide, self);
    },
  });

  L.control.cust2 = function(opts) {
    return new L.Control.Cust2(opts);
  };

  L.control.cust2({ position: "bottomright" }).addTo(leafletMap);
};

export const addThemeToggleButtons = (leafletMap, self) => {
  self.tilelayer = L.maplibreGL({
    attribution:
      '\u003ca href="https://www.maptiler.com/copyright/" target="_blank"\u003e\u0026copy; MapTiler\u003c/a\u003e \u003ca href="https://www.openstreetmap.org/copyright" target="_blank"\u003e\u0026copy; OpenStreetMap contributors\u003c/a\u003e',
    style: process.env.VUE_APP_MAPTILER_STREET,
  }).addTo(leafletMap);
  const isTileLayer = self.layer === "tilelayer";
  L.Control.Cust2 = L.Control.extend({
    onAdd: function() {
      var table = L.DomUtil.create("table");
      table.setAttribute("id", "empTable");
      var tr = table.insertRow(-1);
      var current_button = L.DomUtil.create("input");
      current_button.type = "image";
      current_button.setAttribute("id", "map_button");
      current_button.title = "current";
      current_button.value = "current";
      current_button.src = isTileLayer ? map_button_off : map_button_on;
      current_button.style.width = "40px";
      current_button.style.margin = "px";
      current_button.style.float = "left";
      current_button.style.outline = "none";
      L.DomEvent.addListener(
        current_button,
        "click",
        this._clicked_map_theme,
        this
      );
      L.DomEvent.disableClickPropagation(current_button);
      tr.appendChild(current_button);
      var temp_button = L.DomUtil.create("input");
      temp_button.setAttribute("id", "sat_button");
      temp_button.type = "image";
      temp_button.title = "No cat";
      temp_button.value = "28";
      temp_button.src = isTileLayer ? sat_button_on : sat_button_off;
      temp_button.style.width = "40px";
      temp_button.style.margin = "0px";
      temp_button.style.marginBottom = "15px";
      temp_button.style.border = "none";
      temp_button.style.outline = "none";
      temp_button.style.float = "left";
      L.DomEvent.addListener(
        temp_button,
        "click",
        this._clicked_satellite_theme,
        this
      );
      L.DomEvent.disableClickPropagation(temp_button);
      tr.appendChild(temp_button);
      let maplibreMap = self.tilelayer.getMaplibreMap();
      maplibreMap.setStyle(process.env.VUE_APP_MAPTILER_STREET);
      return table;
    },
    _clicked_map_theme: function() {
      var mapButtonID = document.getElementById("map_button");
      var satButtonID = document.getElementById("sat_button");
      self.current_theme = 1;
      mapButtonID.src = map_button_on;
      satButtonID.src = sat_button_off;
      let maplibreMap = self.tilelayer.getMaplibreMap();
      maplibreMap.setStyle(process.env.VUE_APP_MAPTILER_STREET);
      const updateEvent = {
        mapChangedTo: "map",
        source: "rainScreen",
      };
      setTimeout(function() {
        postMessageToReact(JSON.stringify(updateEvent));
      });
    },
    _clicked_satellite_theme: function() {
      var mapButtonID = document.getElementById("map_button");
      var satButtonID = document.getElementById("sat_button");
      self.current_theme = 0;
      satButtonID.src = sat_button_on;
      mapButtonID.src = map_button_off;
      let maplibreMap = self.tilelayer.getMaplibreMap();
      maplibreMap.setStyle(process.env.VUE_APP_MAPTILER_HYBRID);
      const updateEvent = {
        mapChangedTo: "satellite",
        source: "rainScreen",
      };
      setTimeout(function() {
        postMessageToReact(JSON.stringify(updateEvent));
      });
    },
  });
  L.control.cust2 = function(opts) {
    return new L.Control.Cust2(opts);
  };
  L.control.cust2({ position: "bottomleft" }).addTo(leafletMap);
};

export const addCurrentLocationMarker = (leafletMap, self) => {
  const locationIcon = L.icon({
    iconUrl: location,
    iconSize: [32, 48],
    iconAnchor: [16, 48],
  });

  self.marker = L.marker([self.lat, self.lng], {
    icon: locationIcon,
    draggable: false,
    riseOnHover: true,
  }).addTo(leafletMap);
};

export const addSendMessageOnMapScroll = (leafletMap, self) => {
  const scrollStart = (data) => {
    let postmessage = {
      event: "mapScrolling",
      source: "waterScreen",
    };
    console.log(
      ":: Map scrolling message sent to the native app: ",
      postmessage
    );
    // this.dpMapInitSent("MapInitialized sent to the native app");
    setTimeout(function() {
      postMessageToReact(JSON.stringify(postmessage));
    }, 100);
  };
  leafletMap.on("movestart", scrollStart);
};

export const changeMarkerPositionOnPressingScreen = (leafletMap, self) => {
  const updateMarker = (data) => {
    // leafletMap.panTo(data.latlng);
    self.marker.setLatLng(data.latlng);

    setTimeout(function() {
      postMessageToReact(JSON.stringify(data.latlng));
    });
  };

  // for web
  // let timeout = null;
  // const handleActionStart = (data) => {
  //     timeout = setTimeout(() => updateMarker(data), 1500);
  // }
  // const handleActionEnd = () => {
  //     clearTimeout(timeout)
  // };
  // leafletMap.on("mousedown", handleActionStart)
  // leafletMap.on("mouseup", handleActionEnd);

  // for mobile
  /**
   * Cannot find a way to use touch events under mobile
   * Issues:
   * https://github.com/ddproxy/Leaflet.draw/issues/18
   * https://github.com/zakjan/leaflet-lasso/issues/27
   * https://github.com/Leaflet/Leaflet/issues/1542
   */
  // leafletMap.on("touchstart", handleActionStart)
  // leafletMap.on("touchend", handleActionEnd);
  /**
   * Use contextmenu event as a workaround
   * contextmenu under mobile fires as long press
   * https://leafletjs.com/reference-1.7.1.html#map-contextmenu
   */
  leafletMap.on("contextmenu", updateMarker);
};

/**
 * Show the log text on the screen on top of the content
 * @param text
 */
export const visualLog = (text) => {
  const $log = document.getElementById("log");
  const $logBtn = document.getElementById("resetLog");
  $logBtn.style.display = "block";
  $log.innerText = $log.innerText + " " + text;
};
export const resetVisualLog = () => {
  const $log = document.getElementById("log");
  $log.innerText = "";
};

export const getMarkerIcon = (self, iconMarker, is_selected) => {
  let url_icon = assets[iconMarker];
  let marker_container_size = is_selected ? 34 : 32; // default OR incerase the default size to fit the shadow + enlarge to highlight selection

  //1. Try to get icon object from cache
  if (
    icons[url_icon] !== undefined &&
    icons[url_icon][is_selected] !== undefined
  ) {
    return icons[url_icon][is_selected];
  }

  //2. Create icon object
  let i = L.icon({
    iconUrl: url_icon,
    iconSize: [marker_container_size, marker_container_size], // size of the icon
  });

  //3. Put the icon in cache, so it will used next time
  let is_selected_map = [];
  is_selected_map[is_selected] = i;

  icons[url_icon] = is_selected_map;

  return i;
};

export const addStationsMarkers = (
  ds,
  leafletMap,
  self,
  stations_filter_type,
  lon_1,
  lon_2,
  lat_1,
  lat_2,
  zoomLevel,
  id_st
) => {
  // for (let r = 0; r < rectangels.length; r++) {
  //     leafletMap.removeLayer(rectangels[r]);
  // }

  if (zoomLevel <= 10) {
    addDistributed(
      ds,
      leafletMap,
      self,
      stations_filter_type,
      L.bounds(L.point(lon_1, lat_1), L.point(lon_2, lat_2)),
      id_st
    );
  } else {
    addNormalStationsMarkers(
      ds,
      self,
      stations_filter_type,
      lon_1,
      lon_2,
      lat_1,
      lat_2,
      id_st
    );
  }
};

const addNormalStationsMarkers = (
  ds,
  self,
  stations_filter_type,
  lon_1,
  lon_2,
  lat_1,
  lat_2,
  id_st
) => {
  for (let j = 0; j < ds.length; j++) {
    let st = ds[j];

    if (
      st.longitude > lon_1 &&
      st.longitude < lon_2 &&
      st.latitude > lat_1 &&
      st.latitude < lat_2
    ) {
      if (self.markers.includes(st.uuid, id_st)) {
        continue;
      }

      let full_type = "";
      if (st.isWL) {
        full_type = self.icons["W"];
      } else if (st.isWT) {
        full_type = self.icons["WT"];
      } else if (st.isWD) {
        full_type = self.icons["Q"];
      } else if (st.isTidal) {
        full_type = self.icons["TIDE"];
      }

      self.addMarker(
        st.longitude,
        st.latitude,
        st.uuid,
        stations_filter_type,
        full_type,
        false
      );
    }
  }
};

const addDistributed = (ds, leafletMap, self, stations_filter_type, bounds) => {
  let left_parts = 12;
  let top_parts = 9;

  let left_side_distance = bounds
    .getTopRight()
    .distanceTo(bounds.getBottomRight());
  let top_side_distance = bounds.getTopRight().distanceTo(bounds.getTopLeft());

  let left_side_step = left_side_distance / left_parts;
  let top_side_step = top_side_distance / top_parts;

  for (let i = 1; i <= left_parts; i++) {
    for (let j = 1; j <= top_parts; j++) {
      let x_left_offset = (j - 1) * top_side_step;
      let y_left_offset = i * left_side_step;

      let x_right_offset = j * top_side_step;
      let y_right_offset = (i - 1) * left_side_step;

      let lon_1 = bounds.getBottomLeft().x + x_left_offset;
      let lat_1 = bounds.getBottomLeft().y - y_left_offset;

      let lon_2 = bounds.getBottomLeft().x + x_right_offset;
      let lat_2 = bounds.getBottomLeft().y - y_right_offset;

      // rectangels.push(L.rectangle([[lat_1, lon_1], [lat_2, lon_2]], {fill: false, weight: 1}).addTo(leafletMap));

      addDistributedStationsMarkers(
        ds,
        leafletMap,
        self,
        stations_filter_type,
        lon_1,
        lon_2,
        lat_1,
        lat_2
      );
    }
  }
};

const addDistributedStationsMarkers = (
  ds,
  leafletMap,
  self,
  stations_filter_type,
  lon_1,
  lon_2,
  lat_1,
  lat_2
) => {
  // if station not exists on the map, find first one in rectangle and return
  for (let j = 0; j < ds.length; j++) {
    let st = ds[j];

    if (
      st.longitude > lon_1 &&
      st.longitude < lon_2 &&
      st.latitude > lat_1 &&
      st.latitude < lat_2
    ) {
      let full_type = "";
      if (st.isWL) {
        full_type = self.icons["W"];
      } else if (st.isWT) {
        full_type = self.icons["WT"];
      } else if (st.isWD) {
        full_type = self.icons["Q"];
      } else if (st.isTidal) {
        full_type = self.icons["TIDE"];
      }

      self.addMarker(
        st.longitude,
        st.latitude,
        st.uuid,
        stations_filter_type,
        full_type,
        false
      );

      return;
    }
  }
};

export const changeMapCenter = (leafletMap, self, latlng, country) => {
  leafletMap.panTo(latlng);
  self.marker.setLatLng(latlng);
  self.lat = latlng.lat;
  self.lng = latlng.lng;
  self.country = country;
  console.log(
    ":: the marker position is set to ",
    self.lat,
    " ",
    self.lng,
    " ",
    self.country
  );
  console.log(":: data.latlng ", latlng);
};
